<template>
  <div class="map_info">
    <div class="map_info_icon">
      <slot />
    </div>
    <div class="map_info_text">
      <span>{{ title }}</span>
      <p v-html="description" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
  },
}
</script>

<style lang="less">
.map_info {
  width: 100%;
  height: 175px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 0;
  background-color: white;
  padding: 15px;
  border-radius: 15px;
  box-shadow: 0 3px 36px rgba(122, 122, 122, .16);

  @media screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 28px 17px;
  }

  @media screen and (max-width: 992px) {
    align-items: center;
    padding: 23px 17px;
  }

  @media screen and (max-width: 768px) {
    padding: 20px 17px 25px 17px;
    height: auto;
    margin-bottom: 20px;
  }

  &_icon {
    margin-right: 20px;

    @media screen and (max-width: 1200px) {
      margin-right: 0;
      margin-bottom: 4px;
    }

    @media screen and (max-width: 992px) {
      margin-bottom: 9px;
    }

    img {
      width: 70px;
      height: 70px;
      object-fit: contain;
      object-position: center;

      @media screen and (max-width: 768px) {
        width: 90px;
        height: 90px;
      }
    }
  }

  &_text {
    @media screen and (max-width: 992px) {
      text-align: center;
    }

    span {
      display: block;
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      font-size: 20px;
      padding-bottom: 10px;
    }

    p {
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 300;
      font-size: 14px;
      line-height: 18px;

      strong {
        font-weight: 500;
        white-space: nowrap;
      }
    }
  }
}
</style>
